var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "on-clickaway",
          rawName: "v-on-clickaway",
          value: _vm.away,
          expression: "away"
        }
      ],
      staticClass: "k-dropdown",
      class: {
        "k-dropdown--header-big": _vm.big,
        "k-dropdown--content-above": _vm.above,
        "k-dropdown--display-right": _vm.right,
        "k-dropdown--with-image": _vm.image
      }
    },
    [
      _c(
        "div",
        {
          staticClass: "k-dropdown__header",
          class: { "k-dropdown__header--active": _vm.click },
          on: { click: _vm.toggleDropdown }
        },
        [
          _c(
            "div",
            [
              _vm._t("title"),
              _vm._v(" "),
              _c("i", {
                staticClass: "fa fa-angle-down",
                attrs: { "aria-hidden": "true" }
              })
            ],
            2
          ),
          _vm._v(" "),
          _vm.image
            ? _c(
                "div",
                { staticClass: "k-dropdown__image" },
                [_vm._t("image")],
                2
              )
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "k-dropdown__content" }, [_vm._t("content")], 2)
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-820eac0a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-820eac0a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/element/Dropdown.vue
// module id = 250
// module chunks = 0